export default __webpack_public_path__ + "static/media/la_plata.735a6cf3.jpg";